var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBloodType(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 8,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.7016 17.7998C18.2997 19.0571 17.2897 20.0624 16.0016 20.4998M16.0016 23.1998C13.0241 23.1998 10.6016 20.9182 10.6016 18.1138C10.6016 14.1998 16.0016 8.7998 16.0016 8.7998C16.0016 8.7998 21.4016 14.1998 21.4016 18.1138C21.4016 20.9183 18.9791 23.1998 16.0016 23.1998Z",
    stroke: "#4DBBFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBloodType);
export default __webpack_public_path__ + "static/media/BloodType.cf521276797a9eaba98c55a8a7fd4605.svg";
export { ForwardRef as ReactComponent };